import gsap from "gsap";

export default {
  init() {
    let isOpen = false;
    const trigger = document.querySelector(".book-full__reviews-trigger");
    if (!trigger) {
      return;
    }
    const triggerIcon = trigger.querySelector("i");
    const content = document.querySelector(".book-full__reviews-content");

    trigger.addEventListener("click", () => {
      if (!isOpen) {
        isOpen = true;
        content.style.display = "block";
        gsap.to(triggerIcon, {
          duration: 0.2,
          rotation: 90,
          ease: "power2.inOut",
        });
        gsap.fromTo(
          content,
          { opacity: 0, height: 0 },
          {
            duration: 0.2,
            opacity: 1,
            height: "auto",
            ease: "power2.inOut",
          }
        );
      } else {
        isOpen = false;
        gsap.to(triggerIcon, {
          duration: 0.2,
          rotation: 0,
          ease: "power2.inOut",
        });
        gsap.to(content, {
          duration: 0.2,
          opacity: 0,
          height: 0,
          ease: "power2.inOut",
          onComplete: () => {
            content.style.display = "none"; // Ensure content is hidden after animation
          },
        });
      }
    });
  },
};
